import { Wallet, Check } from 'lucide-react';
import type { UserProfileDto } from '../../../domain/contracts/api.contracts';
import { useTranslation } from '../../../application/hooks/useTranslation';

/** W04 — registered payout account (masked), read-only. */
export function LinkedPaymentCard({ payout }: { payout: UserProfileDto['payout'] }) {
  const { t } = useTranslation();

  const statusPill = payout ? (
    <span className="profile-status-pill profile-pill-gold">
      <Check size={12} aria-hidden />
      {t('profile.pillActive')}
    </span>
  ) : (
    <span className="profile-status-pill profile-pill-neutral">
      {t('profile.pillNotSet')}
    </span>
  );

  return (
    <section className="profile-card">
      <div className="profile-card-header">
        <div className="profile-card-header-main">
          <div className="profile-card-icon-tile profile-icon-gold">
            <Wallet size={18} aria-hidden />
          </div>
          <div className="profile-card-title-wrap">
            <h3 className="profile-card-title">{t('profile.payout')}</h3>
            <p className="profile-card-subtitle">{t('profile.payoutSubtitle')}</p>
          </div>
        </div>
        <div className="profile-card-header-badge">{statusPill}</div>
      </div>

      <div className="profile-card-body">
        {payout ? (
          <dl className="profile-kv-grid kv" data-testid="payout-card">
            <div className="profile-kv-item">
              <dt className="profile-kv-label">{t('profile.payoutMethod')}</dt>
              <dd className="profile-kv-value">{payout.method === 'BKASH' ? 'bKash' : t('profile.payoutBank')}</dd>
            </div>
            <div className="profile-kv-item">
              <dt className="profile-kv-label">{t('profile.payoutAccount')}</dt>
              <dd className="profile-kv-value tabular">{payout.accountMasked}</dd>
            </div>
            <div className="profile-kv-item profile-kv-full">
              <dt className="profile-kv-label">{t('profile.payoutHolder')}</dt>
              <dd className="profile-kv-value">{payout.holderName}</dd>
            </div>
          </dl>
        ) : (
          <div className="profile-empty-state">
            <p className="profile-empty-text muted" data-testid="payout-empty">
              {t('profile.notOnRecord')}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
